import React, { useState } from "react";
import axios from "axios";

const API = "https://login.abhedasramam.org/myapp/api";

function EmagazineUpload({ refreshList }) {
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [url, setUrl] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!month || !year || !url) {
      alert("All fields are required");
      return;
    }
  
    try {
      const res = await axios.post(
        `${API}/save_emagazine.php`,
        { month, year, url },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      console.log("SUCCESS RESPONSE:", res.data);
  
      if (res.data.success) {
        alert("Saved successfully ✅");
  
        setMonth("");
        setYear("");
        setUrl("");
  
        refreshList();
      } else {
        console.error("API ERROR:", res.data);
        alert("API Error: " + (res.data.error || "Unknown error"));
      }
  
    } catch (err) {
      console.error("FULL ERROR:", err);
  
    //   if (err.response) {
    //     console.log("SERVER RESPONSE:", err.response.data);
    //     alert("Server Error: " + JSON.stringify(err.response.data));
    //   } else {
    //     alert("Network Error / CORS issue");
    //   }
    }
  };

  return (
    <div>
      <h4>E-Magazine Upload</h4>

      <form onSubmit={handleSubmit}>
        <div className="row">

          <div className="col-md-6">
            <select
              className="form-control"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            >
              <option value="">Select Month</option>
              <option>January</option>
              <option>February</option>
              <option>March</option>
              <option>April</option>
              <option>May</option>
              <option>June</option>
              <option>July</option>
              <option>August</option>
              <option>September</option>
              <option>October</option>
              <option>November</option>
              <option>December</option>
            </select>
          </div>

          <div className="col-md-6">
            <select
              className="form-control"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="">Select Year</option>
              {Array.from({ length: 20 }, (_, i) => 2025 + i).map((y) => (
                <option key={y}>{y}</option>
              ))}
            </select>
          </div>

          <div className="col-md-12" style={{ marginTop: "10px" }}>
            <textarea
              className="form-control"
              placeholder="Enter Book URL"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              style={{ height: "100px" }}
            />
          </div>

          <div className="col-md-12" style={{ marginTop: "10px" }}>
            <button className="btn leftcolor white" style={{border:'none'}}>Save</button>
          </div>

        </div>
      </form>
    </div>
  );
}

export default EmagazineUpload;